module.exports = __webpack_public_path__ + "static/media/jobs-header.36f239a6.jpg";